import r from "../../shared-lib/braze-shared-lib.js";
import y from "../common/base-provider.js";
import e from "../managers/braze-instance.js";
import { STORAGE_KEYS as o } from "../managers/storage-manager.js";
import u from "../managers/subscription-manager.js";
import { randomInclusive as tt } from "../util/math.js";
import b from "../util/net.js";
import {
  newFeatureFlagFromJson as et,
  newFeatureFlagFromSerializedValue as st
} from "./feature-flag-factory.js";
export default class er extends y {
  constructor(t, s, i) {
    super(),
      (this.gt = t),
      (this.vt = s),
      (this.h = i),
      (this.he = new u()),
      (this.ye = 10),
      (this.Te = null),
      e.jt(this.he);
  }
  Rs(t) {
    if (this.gt._e() && null != t && t.feature_flags) {
      this.Re = [];
      for (const e of t.feature_flags) {
        let t = et(e);
        t && this.Re.push(t);
      }
      (this.De = new Date().getTime()), this.Ne(), this.he.St(this.Re);
    }
  }
  xe() {
    const t = this.h.I(o.q.ze) || {};
    let e = {};
    for (let s in t) {
      let i = st(t[s]);
      i && (e[i.id] = i);
    }
    return e;
  }
  Ws(t) {
    return this.he.ut(t);
  }
  refreshFeatureFlags(t, e, s, i) {
    if (!this.Se(s))
      return (
        this.$e ||
          (this.$e = this.gt.qe(() => {
            this.refreshFeatureFlags(t, e);
          })),
        void ("function" == typeof e && e())
      );
    null == i && (i = !0), i && this.Me();
    const r = this.vt.Ps({}, !0),
      a = this.vt.Bs(r, !1, !0);
    let h = !1;
    this.vt.Gs(r, () => {
      b.Hs({
        url: `${this.vt.Ks()}/feature_flags/sync`,
        headers: a,
        data: r,
        S: s => {
          if (!this.vt.Os(r, s, a))
            return (h = !0), void ("function" == typeof e && e());
          this.vt.Qs(), this.Rs(s), "function" == typeof t && t();
        },
        error: t => {
          this.vt.Vs(t, "retrieving feature flags"),
            (h = !0),
            "function" == typeof e && e();
        },
        Ue: () => {
          if (i && h && !this.ke) {
            let i = this.Te;
            (null == i || i < 1e3 * this.ye) && (i = 1e3 * this.ye),
              this.Ae(Math.min(3e5, tt(1e3 * this.ye, 3 * i)), t, e, s);
          }
        }
      });
    });
  }
  Me() {
    null != this.ke && (clearTimeout(this.ke), (this.ke = null));
  }
  Ae(t, e, s, i) {
    null == t && (t = 1e3 * this.ye),
      this.Me(),
      (this.ke = setTimeout(() => {
        this.refreshFeatureFlags(e, s, i);
      }, t)),
      (this.Te = t);
  }
  Se(t) {
    if (!t) {
      const t = parseFloat(this.gt.Be());
      let e = !1;
      if (!isNaN(t)) {
        if (-1 === t) return r.D.info("Feature flag refreshes not allowed"), !1;
        e = new Date().getTime() >= (this.De || 0) + 1e3 * t;
      }
      if (!e)
        return (
          r.D.info(`Feature flag refreshes were rate limited to ${t} seconds`),
          !1
        );
    }
    return this.gt._e();
  }
  Ne() {
    const t = {};
    for (let e = 0; e < this.Re.length; e++) {
      let s = this.Re[e],
        i = s.ss();
      t[s.id] = i;
    }
    this.h.B(o.q.ze, t), this.h.B(o.q.Ce, this.De);
  }
}
